import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/organization/[tid]/page.tsx");
